import React, { Component } from "react";
import {
    GroundFloorDurableFunctionInstance
} from "../models/DurableFunctionInstance";

import DurableFunctionInstanceStatus from "./DurableFunctionInstanceStatus";
import {calcIsFailedAndAwaitingRestart} from "../utils/Utils";

interface GroundFloorDurableFunctionInstanceStatusProps {
    durableFunctionInstance?: GroundFloorDurableFunctionInstance
    flex?: string | number;
}

interface GroundFloorDurableFunctionInstanceStatusState {

}

export default class GroundFloorDurableFunctionInstanceStatus extends Component<GroundFloorDurableFunctionInstanceStatusProps, GroundFloorDurableFunctionInstanceStatusState> {

    public render() {
        
        let pillColourOverride: string | undefined = undefined;
        let statusTextOverride: string | undefined = undefined;

        const isPlaylistFailedAndAwaitingRestart = calcIsFailedAndAwaitingRestart(this.props.durableFunctionInstance)
        if (isPlaylistFailedAndAwaitingRestart)
        {
            pillColourOverride = "red";
            statusTextOverride = "Failed";
        }
        
        
        return (
            <DurableFunctionInstanceStatus
                durableFunctionInstance={this.props.durableFunctionInstance}
                flex={this.props.flex}
                pillColourOverride={pillColourOverride}
                runtimeStatusTextOverride={statusTextOverride}
            />
        );
    }
}